<form #blockInputs="ngForm">
  <glxy-form-field>
    <glxy-label>{{ 'EMAIL_BUILDER.NET_PROMOTER_SCORE_BLOCK.DISPLAY_AS' | translate }}</glxy-label>
    <mat-radio-group (change)="valueChange($event.value)">
      <mat-radio-button [checked]="this.content.renderType.includes('button')" value="button">
        {{ 'EMAIL_BUILDER.NET_PROMOTER_SCORE_BLOCK.BUTTON' | translate }}
      </mat-radio-button>
      <mat-radio-button [checked]="this.content.renderType.includes('inline')" value="inline">
        {{ 'EMAIL_BUILDER.NET_PROMOTER_SCORE_BLOCK.INLINE' | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </glxy-form-field>
  <glxy-form-field>
    <glxy-label>{{ 'EMAIL_BUILDER.NET_PROMOTER_SCORE_BLOCK.REQUEST_REVIEW' | translate }}</glxy-label>
    <mat-checkbox (change)="valueChangeForCheckBox($event.checked)" [checked]="this.content.redirectCheckBox">
      {{ 'EMAIL_BUILDER.NET_PROMOTER_SCORE_BLOCK.YES' | translate }}
      <extended class="review-request-confirmation-text">{{
        'EMAIL_BUILDER.NET_PROMOTER_SCORE_BLOCK.REQUEST_REVIEW_CONTEXT' | translate
      }}</extended>
    </mat-checkbox>
  </glxy-form-field>
</form>
